import { inject, Injectable } from "@angular/core";
import { environment } from "../../../../../../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { AuthService } from "../../../../../../../../core/service/auth.service";
import { SelectClaimResponse } from "../interfaces/select-claim.interface";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SelectClaimService {

  private apiUrl = environment.apiUrl;
  http = inject(HttpClient);
  authService = inject(AuthService);

  loadListClaims(): Observable<SelectClaimResponse> {
    const token = this.authService.getToken();
    return this.http.get<SelectClaimResponse>(`${this.apiUrl}/missingItems/get`, { headers: { 'Authorization': `Bearer ${token}` } });
  }
}
